import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AIService {
    private env = environment;

    constructor(private http: HttpClient) { }

    getResponse(prompt: string, thread: string = ""): Observable<any> {
        return this.http.post(this.env.api_root.concat('ai_api/langchain_stream/'), { prompt, thread }, {
            responseType: 'text',
            observe: 'events',
            reportProgress: true
        }).pipe(
            // The answer so far as it streams in, then the whole of it when the
            // response ends: browsers fire progress events only now and then, so
            // the last chunk (the link definitions that turn citations into links)
            // can arrive with the final response and no progress event of its own.
            filter(event => event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.Response),
            map(event => event.type === HttpEventType.Response ? event['body'] : event['partialText'])
        );

    }
}